/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'licensing';
const componentName = 'tenant-usage-list';

const prefix = `${moduleName}.${componentName}`;

export const headerLabel = `${prefix}.headerLabel`;
export const columnTenantTitle = `${prefix}.columnTenantTitle`;
export const columnUsedTitle = `${prefix}.columnUsedTitle`;
export const columnLimitTitle = `${prefix}.columnLimitTitle`;
export const actionTitleEdit = `${prefix}.actionTitleEdit`;

export const ENGLISH = {
    [headerLabel]: 'Tenant Usage',
    [columnTenantTitle]: 'Tenant',
    [columnUsedTitle]: 'Used (Service Units)',
    [columnLimitTitle]: 'Limit (Service Units)',
    [actionTitleEdit]: 'Edit',
};
